<template>
<section :class="classes">
	<Heading :level="1" text="Contact Details" />
	<form @submit.prevent="saveAndSubmit" novalidate ref="form">
		<userMessage
			v-if="error"
			message-type="error"
			:message-text="error" />

		<InputField
			ref="ua_companyname"
			name="ua_companyname"
			:help-text="{text: 'Please enter the full official name of your business.'}"
			label-text="Business Name"
			:value="formData.ua_companyname"
			@emitFieldData="(val) => formData.ua_companyname = val"
			required-error="Please provide your business name"
			:validation-rules="[(v) => rules.containsLength(v, 3, null)]" />

		<SelectField
			name="ua_title"
			ref="ua_title"
			label-text="Title"
			:value="formData.ua_title"
			@emitFieldData="(val) => formData.ua_title = val"
			required-error="Please select an option"
			:options-loading="false"
			:options="titleOpts" />

		<template v-if="otherTitle">
			<InputField
				ref="ua_othertitle"
				name="ua_othertitle"
				label-text="Please enter the title you are known by"
				:value="formData.ua_othertitle"
				@emitFieldData="(val) => formData.ua_othertitle = val"
				required-error="Please provide your title" />
		</template>

		<InputField
			ref="ua_firstname"
			name="ua_firstname"
			label-text="Forename(s)"
			:value="formData.ua_firstname"
			@emitFieldData="(val) => formData.ua_firstname = val"
			required-error="Please provide your forename(s)"
			:validation-rules="[(v) => rules.containsLength(v, 2, null)]" />

		<InputField
			ref="ua_lastname"
			name="ua_lastname"
			label-text="Surname"
			:value="formData.ua_lastname"
			@emitFieldData="(val) => formData.ua_lastname = val"
			required-error="Please provide your surname"
			:validation-rules="[(v) => rules.containsLength(v, 2, null)]" />

		<InputField
			ref="ua_preferredcontacttelephoneno"
			name="ua_preferredcontacttelephoneno"
			label-text="Telephone Number"
			input-type="tel"
			placeholder="0000 000 0000"
			:value="formData.ua_preferredcontacttelephoneno"
			@emitFieldData="(val) => formData.ua_preferredcontacttelephoneno = val"
			required-error="Please provide your telephone number"
			:validation-rules="[rules.validateTel]" />

		<InputField
			ref="ua_emailaddress"
			name="ua_emailaddress"
			label-text="Email Address"
			input-type="email"
			:is-disabled="formData.ua_emailaddress !== null"
			:value="formData.ua_emailaddress"
			@emitFieldData="(val) => formData.ua_emailaddress = val"
			required-error="Please provide your email address"
			:validation-rules="[rules.validateEmail]" />

		<HelpText text="Please can you supply directors details to contact in case any specific documentation is required" />

		<InputField
			ref="ua_directornameformfa"
			name="ua_directornameformfa"
			label-text="Director Name"
			:value="formData.ua_directornameformfa"
			@emitFieldData="(val) => formData.ua_directornameformfa = val"
			required-error="Please provide the director name"
			:validation-rules="[(v) => rules.containsLength(v, 2, null)]" />

		<InputField
			ref="ua_directoremailformfa"
			name="ua_directoremailformfa"
			label-text="Director Email Address"
			input-type="email"
			:value="formData.ua_directoremailformfa"
			@emitFieldData="(val) => formData.ua_directoremailformfa = val"
			required-error="Please provide the director email address"
			:validation-rules="[rules.validateEmail]" />
	</form>
</section>
</template>

<script>

import { formSteps } from '@/mixins/eoiFormSteps';
import { validationRules } from '@/utilities/validationRules';
import { formValidator } from '@/mixins/formValidator';

export default {
	name: 'ContactDetails',
	mixins: [formValidator, formSteps],
	props: {
		classes: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			rules: validationRules,
			error: '',
			formData: {
				ua_companyname: '',
				ua_title: '',
				ua_othertitle: '',
				ua_firstname: '',
				ua_lastname: '',
				ua_preferredcontacttelephoneno: '',
				ua_emailaddress: '',
				ua_directornameformfa: '',
				ua_directoremailformfa: ''
			},
			titleOpts: [
				{ label: 'Dr', value: 1 },
				{ label: 'Miss', value: 2 },
				{ label: 'Mr', value: 3 },
				{ label: 'Mrs', value: 4 },
				{ label: 'Ms', value: 5 },
				{ label: 'Professor', value: 6 },
				{ label: 'Other', value: 7 }
			]
		};
	},
	computed: {
		otherTitle () {
			return this.formData.ua_title === '7';
		}
	}
};
</script>
